import { render, staticRenderFns } from "./MovePositionModal.vue?vue&type=template&id=206cf447&scoped=true&"
import script from "./MovePositionModal.vue?vue&type=script&lang=ts&"
export * from "./MovePositionModal.vue?vue&type=script&lang=ts&"
import style0 from "./MovePositionModal.vue?vue&type=style&index=0&id=206cf447&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206cf447",
  null
  
)

export default component.exports